export class Checkboxlist{
    constructor(
      public Checked: boolean,
      public ClaimRequestGuid: string = null,
      public level: number,
    public status:string){ }

  }


// WEBPACK FOOTER //
// ./src/models/checkbox-list.model.ts